/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssetStatus } from './assetStatus';


export interface AssetStatusResponse { 
    status: AssetStatus;
}
export namespace AssetStatusResponse {
}


